import React from 'react'
import FloCheckbox from 'src/components/common/form-elements/FloCheckbox'
import { useLocale } from 'src/lib/hooks/useLocal'
import { useCartContext } from 'src/lib/contexts/CartContext'

export const MarketingConsentControl = () => {
  const { t } = useLocale()
  const {
    getters: { cartUIData },
    actions: { setCartMarketingFlag }
  } = useCartContext()

  return (
    <div className='flex items-center justify-between w-full gap-3'>
      <p className='text-text-xs-regular text-zinc-500'>{t('marketing_flag_subtitle')}</p>
      <FloCheckbox
        name='cartMarketingFlagToggle'
        type='SWITCH'
        value={Boolean(cartUIData.enableMarketingFlag)}
        setValue={(checked: boolean) => setCartMarketingFlag(checked)}
      />
    </div>
  )
}
